var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9938",
    "data-name": "Path 9938",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9939",
    "data-name": "Path 9939",
    d: "M3,10.5A7.5,7.5,0,1,0,10.5,3,7.5,7.5,0,0,0,3,10.5",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9940",
    "data-name": "Path 9940",
    d: "M12,9h.008",
    transform: "translate(-2 -1.5)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9941",
    "data-name": "Path 9941",
    d: "M11,12h.833v3.333h.833",
    transform: "translate(-1.833 -2)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fd15d308c43ff32d0b18d70917a9bbf3.svg";
export { ForwardRef as ReactComponent };